module.exports = __webpack_public_path__ + "static/media/download-white.2581f53b.svg";